import React, { useState } from "react";
import { AiOutlineMenuUnfold } from "react-icons/ai";
import { RiUserSettingsLine } from "react-icons/ri";
import { TbUserEdit } from "react-icons/tb";
import { LuUserSearch } from "react-icons/lu";
import { IoIosLogOut } from "react-icons/io";
import { AiOutlineUserAdd } from "react-icons/ai";
import { AiOutlineMenuFold } from "react-icons/ai";
import { Link } from "react-router-dom";
import Header from "./Header";
const SuperUserNavBar = ({ setActivePage, setSidebarOpen }) => {
  const [open, setOpen] = useState(true);

  const [openSubmenus, setOpenSubmenus] = useState({});

  const [isSubmenuOpen, setIsSubmenuOpen] = useState(false);

  const toggleSubmenu = (menuName) => {
    setOpenSubmenus((prev) => ({
      ...prev,
      [menuName]: !prev[menuName], // Toggle only the clicked submenu
    }));
  };

  const handleSidebarToggle = () => {
    setOpen(!open);
    setSidebarOpen(!open); // Update the sidebar state in the parent component
  };

  const menus = [
    {
      name: "User Maintenance",
      link: "/",
      icon: RiUserSettingsLine,
      submenu: [
        { name: "User Onboarding", link: "/add-user", icon: AiOutlineUserAdd },
      ],
    },
    {
      name: "Search",
      link: "/",
      icon: LuUserSearch,
      submenu: [
        { name: "Search Employees", link: "/search", icon: LuUserSearch },
      ],
    },
  ];

  return (
    <section className="flex gap-6">
      <Header />
      <div
        className={`bg-white h-[calc(100vh-70px)] ${
          open ? "w-72" : "w-16"
        } duration-500 text-black-100 px-4 top-[70px] left-0 overflow-y-auto fixed shadow-md`}
      >
        <div className="py-3 flex justify-end">
          {open ? (
            <AiOutlineMenuFold
              size={26}
              className="cursor-pointer"
              onClick={handleSidebarToggle}
            />
          ) : (
            <AiOutlineMenuUnfold
              size={26}
              className="cursor-pointer"
              onClick={handleSidebarToggle}
            />
          )}
        </div>

        <div className="mt-4 flex flex-col gap-4 relative">
          {menus.map((menu, i) => (
            <div key={i}>
              {/* Parent Menu Item */}
              <div
                className="group flex  items-center text-sm gap-3.5 font-medium p-2 hover:bg-[#1f415b] rounded-md cursor-pointer  text-gray-500 hover:text-white"
                onClick={() => menu.submenu && toggleSubmenu(menu.name)}
              >
                <div>{React.createElement(menu.icon, { size: "20" })}</div>
                <h2
                  style={{ transitionDelay: `${i + 3}00ms` }}
                  className={`whitespace-pre duration-500 ${
                    !open && "opacity-0 translate-x-28 overflow-hidden"
                  }`}
                >
                  {menu.name}
                </h2>

                {/* Show Expand/Collapse Arrow for Submenus */}
                {menu.submenu && (
                  <span className="ml-auto">
                    {openSubmenus[menu.name] ? "▼" : "▶"}
                  </span>
                )}
              </div>

              {/* Submenu Items */}
              {menu.submenu && openSubmenus[menu.name] && (
                <div className="ml-8 flex flex-col gap-2">
                  {menu.submenu.map((sub, j) => (
                    <Link
                      to={sub.link}
                      key={j}
                      className="flex items-center text-sm p-2 pl-8 hover:bg-[#1f415b] rounded-md  text-gray-500 hover:text-white"
                    >
                      {sub.icon &&
                        React.createElement(sub.icon, {
                          size: 18,
                          className: "mr-2 text-black-600",
                        })}
                      <span className="whitespace-nowrap">{sub.name}</span>
                    </Link>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
      <div
        className={`transition-all duration-500 flex-1 p-20 bg-white-100 ${open ? 'pl-72' : 'pl-16'} ml-0`}
      >
      </div>
    </section>
  );
};

export default SuperUserNavBar;
